

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface TreatmentPlanParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface TreatmentPlan {
    id?: any;
    tenantId: any;
    branchId: any;
    name:any;
    code:string;
    snomedCode: number;
    departmentId?:string;
    treatmentClassificationId?:number;
    mappingAttribute?:string;
    parameters?: TreatmentPlanParameter[];
    links?: any;
}


export abstract class TreatmentPlanData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<TreatmentPlan[]>;
    abstract create(url: string, data: TreatmentPlan): Observable<TreatmentPlan[]>;
    abstract update(url: string, data: TreatmentPlan): Observable<TreatmentPlan>;
    abstract delete(url: string): Observable<any>;
}
